import { makeStyles } from '@material-ui/core';

export default makeStyles(
  theme => ({
    formRow: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexFlow: 'row nowrap',
      marginBottom: 14,
    },
    formInput: {
      marginBottom: 16,
    },
    formLabel: {
      color: theme.palette.primary.main,
      opacity: 0.5,
      fontWeight: 500,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
      letterSpacing: '0.2px',
      minWidth: 280,
      maxWidth: 280,
      paddingRight: 15,
      textAlign: 'left',
    },
    enumWrap: {
      width: '50%',
    },
    radioButtonLabel: {
      marginLeft: 0,
      marginRight: 16,
      padding: [8, 24],
      border: [1, 'solid', 'rgba(19, 51, 76, 0.2)'],
      boxSizing: 'border-box',
      borderRadius: 3,
    },
    activeRadioButtonLabel: {
      border: [1, 'solid', theme.palette.secondary.main],
      color: theme.palette.secondary.main,
    },
    fieldWrap: {
      display: 'flex',
      flexFlow: 'row nowrap',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    radioWrap: {
      display: 'flex',
      flexFlow: 'row nowrap',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    rowEnumDatepicker: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
  }),
  { name: 'FormRowEnumDatepicker' },
);
